import { Outlet } from 'react-router-dom';

/**
 * Full-bleed layout for the inside-community view. The community header owns
 * account/toolkit controls inline, so no global nav or bottom nav renders here.
 */
export function CommunityLayout() {
  return (
    <div className="min-h-screen">
      <Outlet />
    </div>
  );
}
